<template>
  <div class="group-info">
    <div class="group-info-header" v-show="isHeaderShow">
      <div class="a" @click="back">
        <img src="./img/back-arrow.png" alt="" />
        <div>返回</div>
      </div>
      <div class="c">群聊信息</div>
      <div class="d"></div>
    </div>
    <div class="group-info-anchor">
      <img :src="groupInfo.avatar" alt="" />
      <div class="desc">
        <div class="up">{{ groupInfo.name }}</div>
        <div class="down">群聊号码：{{ groupInfo.id }}</div>
      </div>
    </div>
    <div class="group-info-title">
      <div class="bar"></div>
      <div>群介绍</div>
    </div>
    <div class="group-info-desc">
      <div class="text" v-show="groupInfo.introduce">
        {{ groupInfo.introduce }}
      </div>
      <div class="text" style="text-align: center" v-show="!groupInfo.introduce">暂无介绍</div>
    </div>
    <div class="group-info-title">
      <div class="bar"></div>
      <div>群成员({{ groupInfo.user_num }}/{{ groupInfo.limit_num }})</div>
    </div>
    <div class="group-info-users">
      <div class="user" v-for="(item, index) in members" :key="index">
        <img :src="item.avatar ? item.avatar : require('@/assets/img/default/default_logo1.png')" alt="" class="avatar" />
        <div class="text text-overflow">{{ item.nick_name }}</div>
      </div>
    </div>
    <div class="group-info-route" @click="toGroupMembers">
      <div>查看全部群成员</div>
      <img src="./img/forward-arrow.png" alt="" />
    </div>
    <div class="group-info-btns">
      <div class="btn" @click="openConfirmDialog(dialogContent1)">清空聊天内容</div>
      <div class="btn btn1" @click="openConfirmDialog(dialogContent2)">删除并退出</div>
    </div>
    <ConfirmDialog :content="content" @confirmDialog="confirmDialog" ref="confirmDialog" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { format } from "@/util/time";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
export default {
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapState(["userInfo", "appConfig", "privateMessageList", "groupInfo"]),
    roomId() {
      return this.liveDetail.anchorid || 0;
    },
    members() {
      if (this.groupInfo.members) {
        return this.groupInfo.members.slice(0, 4);
      }
    },
  },
  props: ["liveDetail", "isHeaderShow"],
  watch: {},
  data() {
    return {
      messageContent: "",
      content: "",
      dialogContent1: ["确定要清空聊天记录吗？"],
      dialogContent2: ["确定要清空聊天记录", "并退出群聊吗？"],
    };
  },
  created() {},
  destroyed() {},
  mounted() {
    // this.getGroupInfo();
  },
  methods: {
    ...mapMutations(["pushToast", "changeGroupMessageList"]),
    ...mapActions(["getAnchorProfile", "getGroupInfo", "getChatList"]),
    toAnchorInfo() {
      this.$emit("toAnchorInfo");
    },
    toGroupMembers() {
      this.$emit("toGroupMembers");
    },
    back() {
      this.$emit("changeGroupInfo", false);
    },
    openConfirmDialog(val) {
      this.content = val;
      this.$refs.confirmDialog.open();
    },
    confirmDialog(val) {
      console.log(val);
      if (val === this.dialogContent1) {
        this.clearHistory();
      }
      if (val === this.dialogContent2) {
        this.clearAndQuit();
      }
    },
    clearHistory() {
      post({
        url: "/api/groupChat/clearHistory",
        data: {
          group_id: this.groupInfo.id,
        },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.$message.success("清空聊天记录成功！");
            this.changeGroupMessageList([]);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clearAndQuit() {
      post({
        url: "/api/groupChat/clearAndQuit",
        data: {
          group_id: this.groupInfo.id,
        },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.$message.success("清空聊天记录并退出群成功！");
            this.$emit("closeGroupInfo");
            this.getChatList();
            this.getAnchorProfile(this.roomId);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.group-info {
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  position: relative;
  .group-info-header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    background: linear-gradient(0deg, rgba(2, 168, 162, 0.15), rgba(2, 168, 162, 0.15)), #ffffff;
    .a {
      display: flex;
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.05rem;
      }
    }
    .c {
      flex: 1;
      text-align: center;
      color: #000000;
    }
    .d {
      width: 0.8rem;
    }
  }
  .group-info-anchor {
    height: 1rem;
    box-shadow: inset 0px -0.5px 0px #f0f0f0;
    display: flex;
    align-items: center;
    img {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 0.6rem;
      margin-left: 0.16rem;
      margin-right: 0.08rem;
      cursor: pointer;
    }
    .desc {
      line-height: 0.24rem;
      .up {
        font-weight: 500;
        font-size: 0.16rem;
      }
      .down {
        color: #999999;
      }
    }
  }
  .group-info-title {
    height: 0.56rem;
    display: flex;
    align-items: center;
    font-size: 0.16rem;
    .bar {
      width: 0.04rem;
      height: 0.09rem;
      background: linear-gradient(180deg, #29f19c 0%, #02a1f9 100%);
      border-radius: 0.04rem;
      margin-left: 0.16rem;
      margin-right: 0.08rem;
    }
  }
  .group-info-desc {
    padding: 0.1rem 0.16rem 0.2rem;
    // height: 1.1rem;
    .text {
      line-height: 0.2rem;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  .group-info-users {
    height: 0.94rem;
    padding: 0 0.16rem;
    display: flex;
    align-items: center;
    gap: 0.12rem;
    .user {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666666;
      width: 0.68rem;
      img {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.5rem;
        margin-bottom: 0.06rem;
      }
      .text {
        width: 0.68rem;
        text-align: center;
      }
    }
  }
  .group-info-route {
    width: 1.32rem;
    height: 0.32rem;
    background: #f4f4f4;
    border-radius: 0.04rem;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.1rem auto 0;
    cursor: pointer;
    img {
      width: 0.16rem;
      margin-left: 0.02rem;
    }
  }
  .group-info-btns {
    position: absolute;
    bottom: 0.1rem;
    width: 3.4rem;
    .btn {
      width: 3rem;
      height: 0.5rem;
      border: 1px solid #dbdbdb;
      border-radius: 0.08rem;
      line-height: 0.5rem;
      text-align: center;
      font-size: 0.16rem;
      margin: 0 auto 0.16rem;
      cursor: pointer;
    }
    .btn1 {
      border: 1px solid #db6372;
      color: #db6372;
    }
  }
}
</style>
